import { type AccountGet } from '@reliance/types/responses/Account/AccountGet';
import { type ApiService, type QueryParams } from '../types/ApiService';

export const account = (centralApi: ApiService) => ({
  get: (ani, params: QueryParams = {}): Promise<AccountGet> => {
    return centralApi.get<AccountGet>(`/account/${ani}`, {
      params,
    });
  },
});
